import { useCallback } from 'react'
import type { JSX } from 'react'
import type { ReactNode } from 'react'

import getErrorBoundary from '~publish/components/ErrorBoundary'
import FittedFallbackComponent from '~publish/components/ErrorBoundary/fallbackComponent'
import { SlateJsProxy } from '~publish/legacy/composer/composer/entities/EditorStateProxy/SlateJsProxy'
import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'

const Boundary = getErrorBoundary(true)

export const EditorErrorBoundary = ({
  children,
  editor,
}: {
  children: ReactNode
  editor: BufferEditor
}): JSX.Element => {
  const onError = useCallback(
    () => ({
      context: 'EditorErrorBoundary',
      editorId: editor?.id ?? 'No id found',
      editorStructure: SlateJsProxy.flattenEditorStructure(editor),
    }),
    [editor],
  )
  return (
    <Boundary fallbackComponent={FittedFallbackComponent} onError={onError}>
      {children}
    </Boundary>
  )
}
